import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

export function Description(props) {
  const renderContent = (content) => {
    return content.map((item, index) => {
      return (
        <p
          className={`${style.description} ${props.className}`}
          key={index}>
          {item}
        </p>
      );
    });
  };

  return renderContent(props.content);
}

Description.propTypes = {
  /**
   * text is used display the content of the tab
   */
  content: PropTypes.arrayOf(PropTypes.string).isRequired,
  /**
   * style to recive from out of the component
   */
  className: PropTypes.string,
};

Description.defaultProps = {
  content: '',
};
